import { Divider, Typography } from "antd";
import BinBlukOutward from "../../../components/DispatchCentre/BlukOutward/Bin/BinBlukOutward";

const BinBlukOutwardPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Dispatch Center Bulk Bin Outward
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan, review, and send multiple bins outward
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <BinBlukOutward userData={userData} />
    </div>
  );
};

export default BinBlukOutwardPage;